<template>
    <section class="assessmentSection levelCompleteSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">15% complete!</div>
            <div class="pageTitle">Ok, let's build a<span v-if="lead.protectionLevel !== 'Total'">n</span> {{ lead.protectionLevel }} System.</div>
            <div class="pagesubTitle">Ready to get started?</div>
            <div class="pageText">
                <section class="assessmentStepsOverview">
                    <div class="assessmentSteps">
                        <div class="assessmentStep">
                            <i class="fa fa-long-arrow-right arrow"></i>
                            Home assessment 
                            <i class="fa fa-info-circle info" @click="showModal('homeAssessment')" /> 
                        </div>
                        <div class="assessmentStep" :class="{'disabled': lead.protectionLevel === 'Essential'}">
                            Evaluate any additional areas of concern 
                            <i class="fa fa-info-circle info" @click="showModal('areasOfConcern')" />
                        </div>
                        <div class="assessmentStep">
                            Review monitoring
                            <i class="fa fa-info-circle info" @click="showModal('monitoring')" />
                        </div>
                        <div class="assessmentStep">
                            Review the system 
                            <i class="fa fa-info-circle info" @click="showModal('system')" />
                        </div>
                    </div>
                </section>
            </div>
            <continue-button to="/assessment/building"
                            :before="mixpanelTracking"
                             text="Start home assessment" />
        </div>

        <!-- MODAL -->
        <div class="modal" ref="homeAssessmentModal" v-show="modals.homeAssessment">
            <div class="modal-content">
                <div class="pageCompleted">What is a home assessment?</div>
                <div class="pageTitle">Basic home information</div>
                <p>
                    Basic information about your home helps us make sure you get the right system.
                </p>
                <button class="button" type="button" @click="closeModal('homeAssessment')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

        <!-- MODAL -->
        <div class="modal" ref="homeAssessmentModal" v-show="modals.areasOfConcern">
            <div class="modal-content">
                <div class="pageCompleted">What is an area of concern?</div>
                <div class="pageTitle">Areas of Concern</div>
                <p>
                    Your home is unique, our areas of concern evaluation gives us insight to make professional recommendations. Specifically around window protection.
                </p>
                <button class="button" type="button" @click="closeModal('areasOfConcern')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

        <!-- MODAL -->
        <div class="modal" ref="homeAssessmentModal" v-show="modals.monitoring">
            <div class="modal-content">
                <div class="pageCompleted">What is monitoring?</div>
                <div class="pageTitle">Monitoring explained</div>
                <p>
                   Monitoring plans are determined based on the features you select.
                </p>
                <button class="button" type="button" @click="closeModal('monitoring')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

        <!-- MODAL -->
        <div class="modal" ref="homeAssessmentModal" v-show="modals.system">
            <div class="modal-content">
                <div class="pageCompleted">What does my system include?</div>
                <div class="pageTitle">Review your system</div>
                <p>
                   Review your quote, and learn more about installation. When you’re ready, you can schedule your install.
                </p>
                <button class="button" type="button" @click="closeModal('system')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
export default {
    data: () => ({
        modals: {
            homeAssessment: false,
            areasOfConcern: false,
            monitoring: false,
            system: false
        }
    }),
    computed: {
        ...mapState(['lead'])
    },
    methods: {
      ...mapActions([]),

      mixpanelTracking() {
          mixpanel.track("startedHomeAssessment")
      },

      showModal(name) {
          this.modals[name] = true
          mixpanel.track('learnMoreAssessment', {
              selection: name
          })
      },

      closeModal(name) {
          this.modals[name] = false
      },
    },
    mounted() {
        this.$Progress.set(15)
    }
}
</script>
